import { ContentChildren, Directive, ElementRef, HostListener, QueryList } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[focusFirstInvalidField]'
})
export class FocusFirstInvalidFieldDirective {
  @ContentChildren(NgModel, { descendants: true, read: ElementRef })
  inputFields!: QueryList<ElementRef>;

  @HostListener('ngSubmit')
  onFormSubmit() {
    const invalidInputFields = this.inputFields.filter(field => {

      return (field.nativeElement as HTMLElement).classList.contains(
        'ng-invalid'
      );
    });
    if (invalidInputFields.length > 0) {
    invalidInputFields[0].nativeElement.focus();
    }
  }

}
